'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _materialUi = require('material-ui');

var _editor = require('@prisma-cms/editor');

var _editor2 = _interopRequireDefault(_editor);

var _Progress = require('material-ui/Progress');

var _Publish = require('material-ui-icons/Publish');

var _Publish2 = _interopRequireDefault(_Publish);

var _Done = require('material-ui-icons/Done');

var _Done2 = _interopRequireDefault(_Done);

var _DoneAll = require('material-ui-icons/DoneAll');

var _DoneAll2 = _interopRequireDefault(_DoneAll);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _prismjs = require('prismjs');

var _prismjs2 = _interopRequireDefault(_prismjs);

require('prismjs/solidity');

var _reactNumberFormat = require('react-number-format');

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import AceEditor from 'react-ace';
// import MonacoEditor from 'react-monaco-editor';
// import * as solidity from "monaco-editor/min/vs/basic-languages/solidity/solidity.js";
// console.log("solidity", solidity);


var styles = function styles(theme) {
  return {
    root: {},
    codeWrapper: {
      whiteSpace: "pre-wrap"
    }
  };
};

var ContractSourceView = function (_EditableView) {
  _inherits(ContractSourceView, _EditableView);

  function ContractSourceView() {
    var _temp, _this, _ret;

    _classCallCheck(this, ContractSourceView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _EditableView.call.apply(_EditableView, [this].concat(args))), _this), _this.state = _extends({}, _EditableView.prototype.state, {
      showPasswordField: false,
      privateKey: "",
      amount: null,
      isDeploying: false
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ContractSourceView.prototype.canEdit = function canEdit() {
    var currentUser = this.context.user;

    var _ref = currentUser || {},
        currentUserId = _ref.id,
        sudo = _ref.sudo;

    var _ref2 = this.getObjectWithMutations() || {},
        id = _ref2.id,
        CreatedBy = _ref2.CreatedBy;

    var _ref3 = CreatedBy || {},
        createdById = _ref3.id;

    return !id || createdById && createdById === currentUserId || sudo === true;
  }; // save() {
  //   const {
  //     user: currentUser,
  //     openLoginForm,
  //   } = this.context;
  //   if (!currentUser) {
  //     return openLoginForm();
  //   }
  //   return super.save();
  // }
  // onSave(result) {
  //   console.log("onSave result", result);
  //   // if (result) {
  //   //   const {
  //   //     data: object,
  //   //   } = result.data && result.data.response || {}
  //   //   const {
  //   //     id,
  //   //   } = object || {};
  //   //   if (id) {
  //   //     const {
  //   //       history,
  //   //     } = this.props;
  //       // history.push(`/eth-accounts/${id}/`);
  //   //   }
  //   // }
  // }


  ContractSourceView.prototype.getCacheKey = function getCacheKey() {
    var _ref4 = this.getObject() || {},
        id = _ref4.id;

    return 'contractSource_' + (id || "new");
  };

  ContractSourceView.prototype.deployContractSource = function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee2() {
      var _this2 = this;

      var createEthTransactionProcessor, _state, isDeploying, privateKey, amount, _getObjectWithMutatio, id, refetch;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              createEthTransactionProcessor = this.context.query.createEthTransactionProcessor;
              _state = this.state, isDeploying = _state.isDeploying, privateKey = _state.privateKey, amount = _state.amount;

              if (!isDeploying) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt('return');

            case 4:
              _getObjectWithMutatio = this.getObjectWithMutations(), id = _getObjectWithMutatio.id;
              refetch = this.props.data.refetch;
              this.setState({
                isDeploying: true
              });
              _context2.next = 9;
              return this.mutate({
                mutation: (0, _graphqlTag2.default)(createEthTransactionProcessor),
                variables: {
                  // where: {
                  //   id,
                  // },
                  data: {
                    type: "ContractCreate",
                    privateKey: privateKey,
                    amount: amount ? parseFloat(amount) : undefined,
                    contractSourceId: id
                  }
                }
              }).then(_asyncToGenerator(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return refetch();

                      case 2:
                        _this2.setState({
                          showPasswordField: false,
                          privateKey: null,
                          amount: null
                        });

                      case 3:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this2);
              }))).catch(function (error) {});

            case 9:
              this.setState({
                isDeploying: false
              });

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function deployContractSource() {
      return _ref5.apply(this, arguments);
    }

    return deployContractSource;
  }();

  ContractSourceView.prototype.getButtons = function getButtons() {
    var _this3 = this;

    var _state2 = this.state,
        isDeploying = _state2.isDeploying,
        showPasswordField = _state2.showPasswordField,
        privateKey = _state2.privateKey,
        amount = _state2.amount;
    var buttons = _EditableView.prototype.getButtons.call(this) || [];

    var _ref7 = this.getObjectWithMutations() || {},
        id = _ref7.id;

    var canEdit = this.canEdit();

    if (canEdit && id) {
      var createEthTransactionProcessorQuery = this.props.createEthTransactionProcessorQuery;

      if (showPasswordField) {
        // buttons.push(<TextField
        //   key="deployPassword"
        //   name="privateKey"
        //   label="Пароль"
        //   value={privateKey || ""}
        //   onChange={event => {
        //     const {
        //       value: privateKey,
        //     } = event.target;
        //     this.setState({
        //       privateKey,
        //     });
        //   }}
        // />);
        buttons.push(this.getTextField({
          Editor: _reactNumberFormat2.default,
          customInput: _materialUi.TextField,
          name: "amount",
          label: "Eth",
          fullWidth: false,
          value: amount || "",
          helperText: "Отправляемая сумма в Eth",
          onChange: function onChange(event) {
            var amount = event.target.value;

            _this3.setState({
              amount: amount
            });
          }
        }));
        buttons.push(this.getTextField({
          name: "privateKey",
          label: "Пароль",
          fullWidth: false,
          value: privateKey || "",
          helperText: "PK от вашего этериум-кошелька",
          onChange: function onChange(event) {
            var privateKey = event.target.value;

            _this3.setState({
              privateKey: privateKey
            });
          }
        }));
      }

      if (isDeploying) {
        buttons.push(_react2.default.createElement(_Progress.CircularProgress, {
          key: 'deployProcess'
        }));
      } else if (createEthTransactionProcessorQuery) {
        buttons.push(_react2.default.createElement(_materialUi.IconButton, {
          key: 'deploy',
          onClick: function onClick(event) {
            if (showPasswordField) {
              _this3.deployContractSource();
            } else {
              _this3.setState({
                showPasswordField: true
              });
            }
          }
        }, _react2.default.createElement(_Publish2.default, null)));
      }
    }

    return buttons;
  };

  ContractSourceView.prototype.renderSource = function renderSource() {
    var _getObjectWithMutatio2 = this.getObjectWithMutations(),
        source = _getObjectWithMutatio2.source;

    var classes = this.props.classes;
    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041A\u043E\u0434 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"));
  };

  ContractSourceView.prototype.renderDefaultView = function renderDefaultView() {
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var _context3 = this.context,
        AccountLink = _context3.AccountLink,
        UserLink = _context3.UserLink,
        Grid = _context3.Grid;
    var contractSourceId = object.id,
        description = object.description,
        source = object.source,
        Accounts = object.Accounts;
    var inEditMode = this.isInEditMode();
    var canEdit = this.canEdit();
    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, description ? _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"), _react2.default.createElement(_editor2.default, {
      value: description
    })) : null, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(Grid, {
      container: true,
      spacing: 16
    }, source ? _react2.default.createElement(Grid, {
      item: true,
      xs: 12,
      md: true
    }, this.renderSource()) : null, Accounts && Accounts.length ? _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u044B"), Accounts.map(function (n) {
      var id = n.id,
          createdAt = n.createdAt,
          address = n.address,
          CreatedBy = n.CreatedBy;

      if (!address) {
        return address;
      }

      return _react2.default.createElement(Grid, {
        key: id,
        container: true,
        alignItems: 'center',
        style: {
          marginBottom: 30
        }
      }, _react2.default.createElement(AccountLink, {
        object: n
      }), _react2.default.createElement(UserLink, {
        user: CreatedBy
      }), ' ', (0, _moment2.default)(createdAt).format('lll'));
    })) : null)));
  };

  ContractSourceView.prototype.renderEditableView = function renderEditableView() {
    var _this4 = this;

    var Grid = this.context.Grid;
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var contractSourceId = object.id,
        description = object.description,
        source = object.source;
    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, this.getTextField({
      name: "name",
      label: "Название контракта"
    })), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"), this.getTextField({
      name: "description",
      label: "Описание контракта",
      Editor: _editor2.default,
      readOnly: false,
      value: description || null,
      onChange: function onChange(description) {
        return _this4.updateObject({
          description: description
        });
      }
    })), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }));
  };

  ContractSourceView.prototype.renderResetButton = function renderResetButton() {
    var _ref8 = this.getObjectWithMutations() || {},
        id = _ref8.id;

    return id ? _EditableView.prototype.renderResetButton.call(this) : null;
  };

  ContractSourceView.prototype.render = function render() {
    if (typeof window === "undefined") {
      return null;
    }

    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return ContractSourceView;
}(_Editable2.default);

exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(ContractSourceView, props);
});
module.exports = exports['default'];